export default "__VITE_ASSET__D9bJva97__"